<ng-container *ngIf="group != null">
  <div
    class="property-field"
    [class.field-technical-info]="field?.name === 'Dimensions_mm'"
    [class.field-disabled]="field?.disabled"
  >
    <label class="property-field-label">{{ field.label }}</label>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="demo-full-width" [formGroup]="group"
      [class.field-readonly]="!field.editable"
      [class.field-editable]="field.editable"
      [class.field-mixed]="field.mixed">
      <input
        matInput
        (change)="changeValue(field.name, $event)"
        [formControlName]="field.name"
        [type]="inputType"
        [attr.inputmode]="inputMode"
        [placeholder]="field.mixed ? 'Multiple values' : ''"
        [attr.aria-label]="field.label"
        [readonly]="!field.editable"
        [class.readonly-field]="!field.editable"
        [class.editable-field]="field.editable"
      />
      <ng-container
        *ngFor="let validation of field.validations"
        ngProjectAs="mat-error"
      >
        <mat-error
          *ngIf="!group?.get(field?.name)?.hasError(validation?.name)"
          >{{ validation?.message }}</mat-error
        >
      </ng-container>
    </mat-form-field>
  </div>
</ng-container>

<ng-container *ngIf="group == null">
  <div
    class="property-field"
    [class.field-technical-info]="field?.name === 'Dimensions_mm'"
    [class.field-disabled]="field?.disabled"
  >
    <label class="property-field-label">{{ field.label }}</label>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="demo-full-width"
      [class.field-readonly]="!field.editable"
      [class.field-editable]="field.editable"
      [class.field-mixed]="field.mixed">
      <input
        matInput
        [type]="inputType"
        [attr.inputmode]="inputMode"
        [placeholder]="field.mixed ? 'Multiple values' : ''"
        [attr.aria-label]="field.label"
        [value]="field.value"
        (change)="changeValue(field.name, $event)"
        [readonly]="!field.editable"
        [class.readonly-field]="!field.editable"
        [class.editable-field]="field.editable"
      />
      <ng-container
        *ngFor="let validation of field.validations"
        ngProjectAs="mat-error"
      >
        <!-- <mat-error *ngIf='!group.get(field.name).hasError(validation.name)'>{{validation.message}}</mat-error> -->
      </ng-container>
    </mat-form-field>
  </div>
</ng-container>
